<!-- 极简模式按钮组 下载/复制-->
<div class="mb-20" *ngIf="SWITCH.IS_SIMPLE_MODE">
    <!-- 类型 -->
    <span>{{i18n.streamlineDiagnosticLabel}}</span>
    <n-help-icon class="btn-help-icon"
        [content]="i18n[LogType.streamlineDiagnostic]">
    </n-help-icon>
    <div *ngIf="!isFirstCollect && !isQueryFalse && !loading"
        class="btn-hidd-when-nodata">
        <!-- 下载 -->
        <button nButton
            theme="text"
            [border]="false"
            [disabledTips]="i18n.fileNonexportableTip"
            [disabled]="this.isFileNonexportable"
            [label]="i18n.downloadBtn"
            (click)="export()">
        </button>
        <n-help-icon class="btn-help-icon"
            [content]="i18n.exportStreamlineDiagnosticLogTip">
        </n-help-icon>
        <!-- 复制 -->
        <button nButton
            id="streamline-dianostic-copy-btn"
            [label]="i18n.copyBtn"
            (click)="copyText()"
            theme="text"
            [border]="false">
        </button>
    </div>
</div>

<!-- 导出日志页面下方展示区域 -->
<n-panel class="streamline-dianostic-panel" [loading]="loading">
    <div class="streamline-dianostic-header">
        <!-- 收集/重新收集按钮 -->
        <button nButton
            style="float: left; margin-right: auto;"
            type="text"
            id="streamline-dianostic-collect-btn"
            icon="icon-refresh"
            [label]="isFirstCollect ? i18n.collectBtn :i18n.recollectBtn"
            (click)="clickCollectBtn()">
        </button>

        <!-- 按钮 -->
        <div class="streamline-dianostic-btns interval-10"
            style="float: right; margin-left: auto;">
            <!-- 二维码/文本切换按钮 -->
            <div class="streamline-dianostic-show-way-options">
                <!-- 二维码 -->
                <div id="streamline-dianostic-show-way-qrcode"
                    class="way-option  option-qrcode"
                    [ngClass]="{'active': streamlineDiagnosticShowWay === StreamlineDiagnosticShowWayTypeE.QRCODE,'unactive': streamlineDiagnosticShowWay === StreamlineDiagnosticShowWayTypeE.TEXT}"
                    (click)="changeStreamlineDiagnosticShowWay(StreamlineDiagnosticShowWayTypeE.QRCODE)">
                    <div>
                        <svg class="icon">
                            <use
                                [attr.xlink:href]="streamlineDiagnosticShowWay === StreamlineDiagnosticShowWayTypeE.QRCODE ? '#app-icon-streamline-dianostic-qrcode-select' : '#app-icon-streamline-dianostic-qrcode-unselect'">
                            </use>
                        </svg>
                    </div>
                </div>
                <!-- 文本 -->
                <div id="streamline-dianostic-show-way-text"
                    class="way-option option-text"
                    [ngClass]="{'active': streamlineDiagnosticShowWay === StreamlineDiagnosticShowWayTypeE.TEXT,'unactive': streamlineDiagnosticShowWay === StreamlineDiagnosticShowWayTypeE.QRCODE}"
                    (click)="changeStreamlineDiagnosticShowWay(StreamlineDiagnosticShowWayTypeE.TEXT)">
                    <div>
                        <svg class="icon">
                            <use
                                [attr.xlink:href]="streamlineDiagnosticShowWay === StreamlineDiagnosticShowWayTypeE.TEXT ? '#app-icon-streamline-dianostic-text-select' : '#app-icon-streamline-dianostic-text-unselect'">
                            </use>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 收集时间提示文本 -->
    <div class="streamline-dianostic-time" *ngIf="!isFirstCollect && !isQueryFalse">
        <p nTextTips class="streamline-dianostic-time-lab">{{fileDateStr}}</p>
        <p nTextTips>{{i18n.timeInfo}}</p>
    </div>

    <!-- 未收集 -->
    <n-nodata *ngIf="isFirstCollect" [text]="false" class="mt-40">
        <p>
            <span>{{i18n.noCollectTip}}</span>
        </p>
    </n-nodata>

    <!-- 展示内容：无数据/二维码/文本 -->
    <div class="streamline-dianostic-show" *ngIf="!isFirstCollect">
        <!-- 已收集无数据 -->
        <n-nodata class="no-data mt-40" *ngIf="isQueryFalse"></n-nodata>

        <!-- 二维码展示区域 -->
        <div *ngIf="streamlineDiagnosticShowWay === StreamlineDiagnosticShowWayTypeE.QRCODE && !isQueryFalse"
            class="img-box" [ngStyle]="{'background-image': 'url(' + qrcodeBorderBackgroundImageUrl + ')'}">
            <!-- 全屏提示遮罩 -->
            <div class="qrcode-mask"
                (click)="changeQrcodeShow()">
                <p class="qrcode-mask-text">{{i18n.fullScreenTip}}</p>
            </div>
            <div class="qrcode-img"
                [innerHTML]="qrImageArr.length === 0 ? '' : (qrImageArr[paginator?.currentPage-1] | safeHtml)"
                (click)="changeQrcodeShow()"></div>
            <ng-container [ngTemplateOutlet]="qrcodePaginatorTemplate">
            </ng-container>
            <ng-container *ngIf="!SWITCH.IS_SIMPLE_MODE"
                [ngTemplateOutlet]="exportButtonTemplate">
            </ng-container>
        </div>

        <!-- 文本框展示区域 -->
        <div *ngIf="streamlineDiagnosticShowWay === StreamlineDiagnosticShowWayTypeE.TEXT && !isQueryFalse">
            <n-iscroll class="streamline-dianostic-text-scroll">
                <div class="streamline-dianostic-text">
                    <span class="streamline-dianostic-text-contain">{{streamlineDiagnostic}}</span>
                </div>
            </n-iscroll>

            <div *ngIf="!SWITCH.IS_SIMPLE_MODE"
                class="streamline-dianostic-text-botton mt-15">
                <!-- 复制按钮 -->
                <button nButton
                    class="mr-10"
                    id="streamline-dianostic-copy-btn"
                    icon="app-icon-analysis-copy"
                    [label]="i18n.copyBtn"
                    type="text"
                    (click)="copyText()">
                </button>

                <!-- 导出按钮 -->
                <ng-container [ngTemplateOutlet]="exportButtonTemplate">
                </ng-container>
            </div>
        </div>
    </div>

    <!-- 精简诊断文件导出下方增加录屏二维码提示内容-->
    <div *ngIf="!isFirstCollect && streamlineDiagnosticShowWay === StreamlineDiagnosticShowWayTypeE.QRCODE && !isQueryFalse">
        <p>
            <span>{{i18n.streamLineDianosticCollectQRcodeLable}}</span>
        </p>
    </div>
</n-panel>

<!-- 二维码展开区域 -->
<n-dialog class="streamline-dianostic-container"
    [(visible)]="isQrcodeFullscreenDisplay"
    [closeBtn]="true"
    (onClose)="changeQrcodeShow()">
    <div>
        <span class="top-tip">{{i18n.fullDiagnosticQrcodeLabel}}</span>
    </div>
    <!-- 二维码 -->
    <div class="full-screen-qrcode-img" [innerHTML]="(qrImageArr[paginator?.currentPage-1] | safeHtml)"></div>

    <!-- 页码、播放速度 -->
    <div class="full-screen-qrcode-footer">
        <ng-container [ngTemplateOutlet]="qrcodePaginatorTemplate">
        </ng-container>
        <span class="top-tip  ml-20">{{i18n.fullDiagnosticQrcodeSpeedLabel}}</span>
        <n-select class="select-width ml-8"
            [options]="playSpeedOptions"
            [(ngModel)]="selectedPlaySpeed"
            (ngModelChange)="changePlaySpeed()">
        </n-select>
    </div>
</n-dialog>

<!-- 页码 -->
<ng-template #qrcodePaginatorTemplate>
    <n-paginator class="qrcode-paginator" #paginator
        [pageStyle]="'simple'"
        [count]="streamlineDiagnostic?.length"
        [offset]="paginatorOffset"
        [limit]="paginatorLimit"
        (onChange)="onPageChange($event)">
    </n-paginator>
</ng-template>

<!-- 导出按钮 -->
<ng-template #exportButtonTemplate>
    <div class="export-btn">
        <button nButton
            id="streamline-dianostic-export-btn"
            [disabledTips]="i18n.fileNonexportableTip"
            [disabled]="this.isFileNonexportable"
            [label]="i18n.download"
            type="text"
            icon="icon-download"
            (click)="export()">
        </button>
        <n-help-icon
            [content]="i18n.exportStreamlineDiagnosticLogTip">
        </n-help-icon>
    </div>
</ng-template>